// extracted by css-extract-rspack-plugin
export default {"cls1":"PreprintSuggestionsStep-cls1_Ve3","cls2":"PreprintSuggestionsStep-cls2_S-O PreprintSuggestionsStep-cls1_Ve3"};